import React, { useState } from 'react';
import Button from 'components/shared/Button';
import s from './BookingCheckout.module.scss';
import useGetPromocodes from 'sdk/hooks/shop/useGetPromocodes';
import useIsAuth from 'sdk/hooks/useIsAuth';

const Promocode = ({ bookingItems, onApplyDiscount }) => {
  const [promoInput, setPromoInput] = useState('');
  const [error, setError] = useState('');
  const { data: isAuthData } = useIsAuth();
  const userId = isAuthData?.user?.id;
  const { data: promocodes } = useGetPromocodes(userId, 'booking');

  const handleApply = () => {
    if (!promoInput.trim()) return;

    const matchingPromo = promocodes?.find(
      (promo) => promo.promocode.toLowerCase() === promoInput.toLowerCase()
    );

    if (!matchingPromo) {
      setError('The promo code wont find');
      return;
    }

    let isApplied = false;
    let promoApplied = false;

    const updatedItems = bookingItems.map((item) => {
      if (
        matchingPromo.service &&
        item.service === matchingPromo.service &&
        !promoApplied
      ) {
        const discount = (item.price * matchingPromo.percent) / 100;
        promoApplied = true;
        isApplied = true;

        return {
          ...item,
          discountedPrice: item.price - discount,
          appliedPromocode: matchingPromo.promocode,
        };
      }

      return item;
    });

    if (!isApplied) {
      setError('The promo code wont find');
      return;
    }

    setError('');
    onApplyDiscount(updatedItems);
  };

  React.useEffect(() => {
    setError('')
  }, [promoInput])

  return (
    <div>
      <div className={`${s.promocode} ${error ? s.promocodeError : undefined}`}>
        <input
          className={s.promocode_field}
          type="text"
          placeholder="PROMO CODE"
          value={promoInput}
          onChange={(e) => setPromoInput(e.target.value)}
        />
        <Button secondarySmall yellow onClick={handleApply}>
          APPLY
        </Button>
      </div>
      {error && <div className={s.promocode_error}>{error}</div>}
    </div>
  );
};

export default Promocode;

